import React, { useContext, useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { Link } from "react-router-dom";
import { BlockVessel } from "../../api/blockVessel";
import { VesselListOnload } from "../../api/VesselListOnLoad";
import { Preloading } from "../../components/Preloading";
import { MyContext } from "../dashboard/Dashboard";

const VesselList = () => {
  const { setValue } = useContext(MyContext);
  const [vesselList, setVesselList] = useState([]);
  const [loading, setLoading] = useState(false);

  // const data = [
  //   { name: "Vessel1" },
  //   { name: "Vessel2" },
  //   { name: "Vessel3" },
  //   { name: "Vessel4" },
  // ];

  useEffect(() => {
    setValue("Vessels");
    async function fetchData() {
      setLoading(true);
      try {
        const  data  = await VesselListOnload();
        setLoading(false);
        if (!data) {
          NotificationManager.warning(
            "Couldn't find any response",
            "Api Error"
          );
        } else {
          setVesselList(data.vessel);
        }
      } catch (error) {
        setLoading(false);

        NotificationManager.error(
          "Network error. Please check your connection",
          "Failed to collect data"
        );
      }
    }
    fetchData();
  }, [setValue]);

  const blockHandler = async (id) => {
    const response = await BlockVessel(id);
    // do change according to response
  };

  return (
    <>
      {loading && <Preloading />}
      {vesselList && (
        <>
          <div className="px-6 pt-6 2xl:container">
            <div className="w-full px-6 py-8 rounded-lg shadow-lg bg-white">
              <div className="flex justify-end mb-4">
                <Link to="/dashboard/create-vessel">
                  <button className="btn btn-sm">
                    <span className="text-xs">Create New Vessel</span>
                  </button>
                </Link>
              </div>
              <div className="overflow-x-auto w-full">
                <table className="table w-full">
                  {/* head */}
                  <thead>
                    <tr>
                      <th>Vessel</th>
                      <th>Client</th>
                      <th>IMO Number</th>
                      <th>MMSI Number</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {vesselList.map((list) => (
                      <tr key={list.v_id}>
                        <td>
                          <div className="flex items-center space-x-3">
                            <div>
                              <div className="font-bold">
                                {list.vessel_name}
                              </div>
                              {/* <div className="text-sm opacity-50">
                                United States
                              </div> */}
                            </div>
                          </div>
                        </td>
                        <td>
                          {list.c_id}
                          {/* <span className="badge badge-ghost badge-sm">Desktop Support Technician</span> */}
                        </td>
                        <td>{list.imo_number}</td>
                        <td>{list.mmsi_number}</td>
                        <th>
                          <button
                            className="btn btn-ghost btn-xs"
                            onClick={() => {
                              blockHandler(list.v_id);
                            }}
                          >
                            Block
                          </button>
                        </th>
                      </tr>
                    ))}
                  </tbody>
                  {/* foot */}
                  <tfoot>
                    <tr>
                      <th>Vessel</th>
                      <th>Client</th>
                      <th>IMO Number</th>
                      <th>MMSI Number</th>
                      <th></th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default VesselList;
